/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { JSONFieldDisplay } from "./display";
import { JSONFieldEdit } from "./edit";

const JSONField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <JSONFieldDisplay />,
        editComponent: <JSONFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};

JSONField.displayName = "JSONField";
export { JSONField };
